import React from 'react';
import Icon from '../../../components/AppIcon';

const TrailerDetailsCard = ({ trailer }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-3 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name="Truck" size={20} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <h2 className="font-heading text-2xl font-semibold text-foreground">
          Trailer Details
        </h2>
      </div>

      <div className="flex flex-col md:flex-row gap-6">
        {/* Trailer Image */}
        <div className="md:w-2/5">
          <img
            src={trailer?.image}
            alt={trailer?.imageAlt}
            className="w-full h-48 md:h-full object-cover rounded-lg"
          />
        </div>

        {/* Trailer Info */}
        <div className="md:w-3/5 space-y-4">
          <div>
            <h3 className="font-heading text-xl font-semibold text-foreground mb-2">
              {trailer?.title}
            </h3>
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="MapPin" size={16} strokeWidth={2} />
              <span className="font-body text-sm">{trailer?.location}</span>
            </div>
            <div className="flex items-center space-x-2 text-muted-foreground mt-1">
              <Icon name="Tag" size={16} strokeWidth={2} />
              <span className="font-body text-sm">{trailer?.type}</span>
            </div>
          </div>

          {/* Specifications */}
          <div className="pt-4 border-t border-border">
            <h4 className="font-heading text-base font-semibold text-foreground mb-3">
              Specifications
            </h4>
            <div className="grid grid-cols-2 gap-3">
              <div className="flex items-center space-x-2">
                <Icon name="Ruler" size={16} color="var(--color-primary)" strokeWidth={2} />
                <div>
                  <p className="font-caption text-xs text-muted-foreground">Length</p>
                  <p className="font-body text-sm font-medium text-foreground">{trailer?.specifications?.length}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Maximize2" size={16} color="var(--color-primary)" strokeWidth={2} />
                <div>
                  <p className="font-caption text-xs text-muted-foreground">Width</p>
                  <p className="font-body text-sm font-medium text-foreground">{trailer?.specifications?.width}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="ArrowUpDown" size={16} color="var(--color-primary)" strokeWidth={2} />
                <div>
                  <p className="font-caption text-xs text-muted-foreground">Height</p>
                  <p className="font-body text-sm font-medium text-foreground">{trailer?.specifications?.height}</p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Weight" size={16} color="var(--color-primary)" strokeWidth={2} />
                <div>
                  <p className="font-caption text-xs text-muted-foreground">Capacity</p>
                  <p className="font-body text-sm font-medium text-foreground">{trailer?.specifications?.capacity}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Key Features */}
          <div className="pt-4 border-t border-border">
            <h4 className="font-heading text-base font-semibold text-foreground mb-3">
              Key Features
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {trailer?.specifications?.features?.map((feature, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <Icon name="CheckCircle2" size={14} color="var(--color-success)" strokeWidth={2} />
                  <span className="font-body text-sm text-foreground">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrailerDetailsCard;